import Cookies from "universal-cookie"
import Collection from "./Collection"
import {
  APIError,
  get,
  post,
} from "./rest"

const USER = 0
const ADMIN = 1

export class User extends Collection {
  firstname = "Unknown"
  lastname = "User"
  email = ""
  handle = ""
  avatar = ""
  role = USER
  report_count = 0
  isDefault = true
  following = []
  followers = []
  authFollowing = false
  preferences = {}

  /**
   * Create a user from data from API
   *
   * @param data
   * @returns
   */
  static create = (data) => {
    // create user
    const user = new User()
    user.hydrate(data)
    user.isDefault = false
    return user
  }

  /**
   * Execute login and return user object and followers
   *
   * @param info
   * @param token
   * @returns user
   */
  static login = async (global, info, controller = null) => {
    const data = await post("login", info, null, controller)
    const token = data.accessToken
    const user = User.create(data.user)
    return user.setLogin(global, token)
  }

  /**
   * Execute logout. Clear token and set user to default
   *
   * @param global
   */
  static logout = async (global, controller) => {
    await post("logout", {}, global.getToken(), controller)
    global.setToken("")
    global.setUser(null)
    User.resetToken()
  }

  /**
   * Register specified user. Store login for user
   *
   * @param info
   * @param global
   * @returns user
   */
  static register = async (global, info, controller) => {
    const data = await post("register", info, null, controller)
    if (data.error) throw new APIError(data.error.message)

    const token = data.accessToken
    const user = User.create(data.user)
    return user.setLogin(global, token)
  }

  /**
   * Load a user and follower and following lists.
   * Create object from data
   *
   * @param token user authentication token
   * @returns
   */
  static loadFromToken = async (token) => {
    // fetch user information from api
    const data = await get("user", token, null)
    return User.create(data.user)
  }

  /**
   * Load a user. Create object from data
   *
   * @param id user id
   * @returns
   */
  static loadFromId = async (id, token, controller) => {
    // fetch user information from api
    const data = await get("user/" + id, token, controller)
    return User.create(data.user)
  }

  /**
   * Store the token in cookie
   *
   * @param token
   */
  static setToken = (token) => User.setCookie("token", token)
  static resetToken = () => User.setCookie("token", null)

  /**
   * Set the cookie specified for all subdomains
   * of the current host.git add
   * 
   * @param {*} key 
   * @param {*} value 
  */
  static setCookie = (key, value) => {
    const parts = window.location.hostname.split('.')
    const hostname = parts.slice(-2).join('.')
    const secure = window.location.protocol.includes("https")
    const cookies = new Cookies()
    cookies.set(key, value, {
      path: "/",
      domain: '.' + hostname,
      secure,
      maxAge: 30 * 3600
    })
  }

  /**
   * Get the token from cookie
   *
   * @param token
   */
  static getToken = () => User.getCookie("token")

  /**
   * Get the cookie specified
   * 
   * @param {*} key 
   * @param {*} value 
  */
  static getCookie = (key) => {
    const cookies = new Cookies()
    return cookies.get(key)
  }

  isAdmin = () => this.role === ADMIN

  name = () => User.makeName(this)

  static makeName = (user) => {
    if (!user)
      return ''

    if (user.handle === 'anonymous')
      return "Anonymous User"

    return user.firstname +
      (user.firstname && user.lastname ? " " : "") +
      user.lastname
  }

  static sortComparator = (v1, v2) => {
    const name1 = v1 ? User.makeName(v1) : 'zzzzzzzzzzzzzzzzzzzzzzz'
    const name2 = v2 ? User.makeName(v2) : 'zzzzzzzzzzzzzzzzzzzzzzz'
    return name1.localeCompare(name2)
  }

  /**
   * Store the login information for this user. This includes
   * updating global contact and storage with the user and token
   * information and sending push token to the server
   *
   * @param global
   * @param token
   * @returns user
   */
  setLogin = (global, token) => {
    // set the global user values
    global.setToken(token)
    global.setUser(this)

    // store the token for next load
    User.setToken(token)

    return this
  }
}
